import axios from "axios"

const Index = ({ websiteData }) => {
  // Prepend '/blog/' to all links
  const html = websiteData.replace(/href="\/([^"]+)"/g, `href="/blog/$1"`)

  return <div dangerouslySetInnerHTML={{ __html: html }} />
}

export async function getStaticProps() {
  const pageToFetch = process.env.WEBFLOW_URL
  const { data } = await axios.get(pageToFetch)
  return {
    props: {
      websiteData: data,
    },
    revalidate: 10, // In seconds
  }
}

export default Index
